import React from 'react';

import { Icon, Space } from '@sravni/react-design-system';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { Flashlight, Shield } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';

import sideBlocksStyles from '../side-blocks.module.scss';

const REASONS = [
  {
    IconComponent: Shield,
    text: 'Внимательно анализируем каждую ситуацию',
  },
  {
    IconComponent: Flashlight,
    text: 'Ответ от представителя организации и экспертов Сравни',
  },
];

export const WhyTrustUs: React.FC = () => {
  const cx = useStyles(sideBlocksStyles);

  return (
    <div className={cx('wrapper')}>
      <Space direction={'vertical'} size={24}>
        <Heading level={4}>Почему нам доверяют</Heading>
        <Space direction={'vertical'} size={16}>
          {REASONS.map(({ IconComponent, text }) => (
            <Space direction={'horizontal'} size={12} key={text}>
              <Icon background="dark" size={16} shape="round">
                <IconComponent className={'h-color-D60'} />
              </Icon>
              <Text size={14}>{text}</Text>
            </Space>
          ))}
        </Space>
        <Text size={14}>
          <Link href={'https://www.sravni.ru/document/review-rules/'} strong>
            Подробнее
          </Link>
        </Text>
      </Space>
    </div>
  );
};
